import { Component, Inject, Injector, OnInit, Optional } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AppComponentBase } from '@app/app-component.base';

@Component({
  selector: 'app-modalaliassformat',
  templateUrl: './modalaliassformat.component.html',
  styleUrls: ['./modalaliassformat.component.less']
})
export class ModalaliassformatComponent extends AppComponentBase implements OnInit {

  constructor(injector: Injector,
    public _dialogRef: MatDialogRef<ModalaliassformatComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any) {
    super(injector);
   }

  ngOnInit() {
  }
  close(): void {
    this._dialogRef.close(true);
  }

}
